<template>
  <selectTree
    v-model="currentValue"
    :multiple="true"
    :maxTagCount="5"
    type="4"
    ref="selectTreeRef"
    :orgId="orgId"
    :disabled="disabled"
    @treeClick="treeClick"
    :checkChild="false"
    @getTreeData="getTreeData"
    :showCloseIcon="false"
  ></selectTree>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {selectTree},
  props: {
    value: null,
    disabled: null,
    orgId: null,
  },
  data() {
    return {
      treeData:[],
    };
  },
  watch: {
    orgId:{
      handler(newVal) {
        if (!newVal) {
          return;
        }
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true);
      },
      immediate: true
    }
  },
  computed: {
    currentValue: {
      // 动态计算currentValue的值
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit("input", val);
      }
    }
  },
  created() {},
  mounted() {
    this.$refs.selectTreeRef.openChange(true);
  },
  methods: {
    // 数据权限组织树
    getTreeData(treeData) {
      this.treeData = treeData;
      this.$nextTick(() => {
        this.deepCheck(treeData);
        this.$refs.selectTreeRef.setSelectIdByChecked();
      });
    },
    // 递归遍历树，设置选中
    deepCheck(treeData) {
      treeData.forEach(item => {
        item.checked = true;
        if (item.children.length) {
          this.deepCheck(item.children);
        }
      });
    },
    // 权限勾选
    treeClick(data) {
      if (data.checked) {
        if (this.treeData[0].id != data.id) {
          //当前节点不是顶级的直接子级
          this.findTreeParent(this.treeData, data.parentId);
        }
        this.findTreeList([data], true); //勾选子级
      } else {
        this.findTreeList([data], false); //去掉子级勾选
      }
      this.$refs.selectTreeRef.setSelectIdByChecked();
    },
    // 数据权限勾选
    findTreeParent(tree, id) {
      tree.find(item => {
        if (item.id == id) {
          this.$set(item, 'checked', true);
          if (!item.isTop) {
            //存在非顶级继续查找
            return this.findTreeParent(this.treeData, item.parentId);
          } else {
            return true;
          }
        }
        if (item.children && item.children.length) {
          return this.findTreeParent(item.children, id);
        }
        return false;
      });
    },
    // 数据权限勾选
    findTreeList(tree, checked) {
      tree.forEach(item => {
        this.$set(item, 'checked', checked);
        if (item.children && item.children.length) {
          this.findTreeList(item.children, checked);
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
</style>